export const Countries = [
  {
    title: 'Select country of residence',
    default: true,
  },
  {
    title: 'Afghanistan',
    dial_code: '+93',
    code: 'AF',
  },
  {
    title: 'Aland Islands',
    dial_code: '+358',
    code: 'AX',
  },
  {
    title: 'Albania',
    dial_code: '+355',
    code: 'AL',
  },
  {
    title: 'Algeria',
    dial_code: '+213',
    code: 'DZ',
  },
  {
    title: 'AmericanSamoa',
    dial_code: '+1 684',
    code: 'AS',
  },
  {
    title: 'Andorra',
    dial_code: '+376',
    code: 'AD',
  },
  {
    title: 'Angola',
    dial_code: '+244',
    code: 'AO',
  },
  {
    title: 'Anguilla',
    dial_code: '+1 264',
    code: 'AI',
  },
  {
    title: 'Antarctica',
    dial_code: '+672',
    code: 'AQ',
  },
  {
    title: 'Antigua and Barbuda',
    dial_code: '+1268',
    code: 'AG',
  },
  {
    title: 'Argentina',
    dial_code: '+54',
    code: 'AR',
  },
  {
    title: 'Armenia',
    dial_code: '+374',
    code: 'AM',
  },
  {
    title: 'Aruba',
    dial_code: '+297',
    code: 'AW',
  },
  {
    title: 'Australia',
    dial_code: '+61',
    code: 'AU',
  },
  {
    title: 'Austria',
    dial_code: '+43',
    code: 'AT',
  },
  {
    title: 'Azerbaijan',
    dial_code: '+994',
    code: 'AZ',
  },
  {
    title: 'Bahamas',
    dial_code: '+1 242',
    code: 'BS',
  },
  {
    title: 'Bahrain',
    dial_code: '+973',
    code: 'BH',
  },
  {
    title: 'Bangladesh',
    dial_code: '+880',
    code: 'BD',
  },
  {
    title: 'Barbados',
    dial_code: '+1 246',
    code: 'BB',
  },
  {
    title: 'Belarus',
    dial_code: '+375',
    code: 'BY',
  },
  {
    title: 'Belgium',
    dial_code: '+32',
    code: 'BE',
  },
  {
    title: 'Belize',
    dial_code: '+501',
    code: 'BZ',
  },
  {
    title: 'Benin',
    dial_code: '+229',
    code: 'BJ',
  },
  {
    title: 'Bermuda',
    dial_code: '+1 441',
    code: 'BM',
  },
  {
    title: 'Bhutan',
    dial_code: '+975',
    code: 'BT',
  },
  {
    title: 'Bolivia, Plurinational State of',
    dial_code: '+591',
    code: 'BO',
  },
  {
    title: 'Bosnia and Herzegovina',
    dial_code: '+387',
    code: 'BA',
  },
  {
    title: 'Botswana',
    dial_code: '+267',
    code: 'BW',
  },
  {
    title: 'Brazil',
    dial_code: '+55',
    code: 'BR',
  },
  {
    title: 'British Indian Ocean Territory',
    dial_code: '+246',
    code: 'IO',
  },
  {
    title: 'Brunei Darussalam',
    dial_code: '+673',
    code: 'BN',
  },
  {
    title: 'Bulgaria',
    dial_code: '+359',
    code: 'BG',
  },
  {
    title: 'Burkina Faso',
    dial_code: '+226',
    code: 'BF',
  },
  {
    title: 'Burundi',
    dial_code: '+257',
    code: 'BI',
  },
  {
    title: 'Cambodia',
    dial_code: '+855',
    code: 'KH',
  },
  {
    title: 'Cameroon',
    dial_code: '+237',
    code: 'CM',
  },
  {
    title: 'Canada',
    dial_code: '+1',
    code: 'CA',
  },
  {
    title: 'Cape Verde',
    dial_code: '+238',
    code: 'CV',
  },
  {
    title: 'Cayman Islands',
    dial_code: '+ 345',
    code: 'KY',
  },
  {
    title: 'Central African Republic',
    dial_code: '+236',
    code: 'CF',
  },
  {
    title: 'Chad',
    dial_code: '+235',
    code: 'TD',
  },
  {
    title: 'Chile',
    dial_code: '+56',
    code: 'CL',
  },
  {
    title: 'China',
    dial_code: '+86',
    code: 'CN',
  },
  {
    title: 'Christmas Island',
    dial_code: '+61',
    code: 'CX',
  },
  {
    title: 'Cocos (Keeling) Islands',
    dial_code: '+61',
    code: 'CC',
  },
  {
    title: 'Colombia',
    dial_code: '+57',
    code: 'CO',
  },
  {
    title: 'Comoros',
    dial_code: '+269',
    code: 'KM',
  },
  {
    title: 'Congo',
    dial_code: '+242',
    code: 'CG',
  },
  {
    title: 'Congo, The Democratic Republic of the Congo',
    dial_code: '+243',
    code: 'CD',
  },
  {
    title: 'Cook Islands',
    dial_code: '+682',
    code: 'CK',
  },
  {
    title: 'Costa Rica',
    dial_code: '+506',
    code: 'CR',
  },
  {
    title: "Cote d'Ivoire",
    dial_code: '+225',
    code: 'CI',
  },
  {
    title: 'Croatia',
    dial_code: '+385',
    code: 'HR',
  },
  {
    title: 'Cuba',
    dial_code: '+53',
    code: 'CU',
  },
  {
    title: 'Cyprus',
    dial_code: '+357',
    code: 'CY',
  },
  {
    title: 'Czech Republic',
    dial_code: '+420',
    code: 'CZ',
  },
  {
    title: 'Denmark',
    dial_code: '+45',
    code: 'DK',
  },
  {
    title: 'Djibouti',
    dial_code: '+253',
    code: 'DJ',
  },
  {
    title: 'Dominica',
    dial_code: '+1 767',
    code: 'DM',
  },
  {
    title: 'Dominican Republic',
    dial_code: '+1 849',
    code: 'DO',
  },
  {
    title: 'Ecuador',
    dial_code: '+593',
    code: 'EC',
  },
  {
    title: 'Egypt',
    dial_code: '+20',
    code: 'EG',
  },
  {
    title: 'El Salvador',
    dial_code: '+503',
    code: 'SV',
  },
  {
    title: 'Equatorial Guinea',
    dial_code: '+240',
    code: 'GQ',
  },
  {
    title: 'Eritrea',
    dial_code: '+291',
    code: 'ER',
  },
  {
    title: 'Estonia',
    dial_code: '+372',
    code: 'EE',
  },
  {
    title: 'Ethiopia',
    dial_code: '+251',
    code: 'ET',
  },
  {
    title: 'Falkland Islands (Malvinas)',
    dial_code: '+500',
    code: 'FK',
  },
  {
    title: 'Faroe Islands',
    dial_code: '+298',
    code: 'FO',
  },
  {
    title: 'Fiji',
    dial_code: '+679',
    code: 'FJ',
  },
  {
    title: 'Finland',
    dial_code: '+358',
    code: 'FI',
  },
  {
    title: 'France',
    dial_code: '+33',
    code: 'FR',
  },
  {
    title: 'French Guiana',
    dial_code: '+594',
    code: 'GF',
  },
  {
    title: 'French Polynesia',
    dial_code: '+689',
    code: 'PF',
  },
  {
    title: 'Gabon',
    dial_code: '+241',
    code: 'GA',
  },
  {
    title: 'Gambia',
    dial_code: '+220',
    code: 'GM',
  },
  {
    title: 'Georgia',
    dial_code: '+995',
    code: 'GE',
  },
  {
    title: 'Germany',
    dial_code: '+49',
    code: 'DE',
  },
  {
    title: 'Ghana',
    dial_code: '+233',
    code: 'GH',
  },
  {
    title: 'Gibraltar',
    dial_code: '+350',
    code: 'GI',
  },
  {
    title: 'Greece',
    dial_code: '+30',
    code: 'GR',
  },
  {
    title: 'Greenland',
    dial_code: '+299',
    code: 'GL',
  },
  {
    title: 'Grenada',
    dial_code: '+1 473',
    code: 'GD',
  },
  {
    title: 'Guadeloupe',
    dial_code: '+590',
    code: 'GP',
  },
  {
    title: 'Guam',
    dial_code: '+1 671',
    code: 'GU',
  },
  {
    title: 'Guatemala',
    dial_code: '+502',
    code: 'GT',
  },
  {
    title: 'Guernsey',
    dial_code: '+44',
    code: 'GG',
  },
  {
    title: 'Guinea',
    dial_code: '+224',
    code: 'GN',
  },
  {
    title: 'Guinea-Bissau',
    dial_code: '+245',
    code: 'GW',
  },
  {
    title: 'Guyana',
    dial_code: '+595',
    code: 'GY',
  },
  {
    title: 'Haiti',
    dial_code: '+509',
    code: 'HT',
  },
  {
    title: 'Holy See (Vatican City State)',
    dial_code: '+379',
    code: 'VA',
  },
  {
    title: 'Honduras',
    dial_code: '+504',
    code: 'HN',
  },
  {
    title: 'Hong Kong',
    dial_code: '+852',
    code: 'HK',
  },
  {
    title: 'Hungary',
    dial_code: '+36',
    code: 'HU',
  },
  {
    title: 'Iceland',
    dial_code: '+354',
    code: 'IS',
  },
  {
    title: 'India',
    dial_code: '+91',
    code: 'IN',
  },
  {
    title: 'Indonesia',
    dial_code: '+62',
    code: 'ID',
  },
  {
    title: 'Iran, Islamic Republic of Persian Gulf',
    dial_code: '+98',
    code: 'IR',
  },
  {
    title: 'Iraq',
    dial_code: '+964',
    code: 'IQ',
  },
  {
    title: 'Ireland',
    dial_code: '+353',
    code: 'IE',
  },
  {
    title: 'Isle of Man',
    dial_code: '+44',
    code: 'IM',
  },
  {
    title: 'Israel',
    dial_code: '+972',
    code: 'IL',
  },
  {
    title: 'Italy',
    dial_code: '+39',
    code: 'IT',
  },
  {
    title: 'Jamaica',
    dial_code: '+1 876',
    code: 'JM',
  },
  {
    title: 'Japan',
    dial_code: '+81',
    code: 'JP',
  },
  {
    title: 'Jersey',
    dial_code: '+44',
    code: 'JE',
  },
  {
    title: 'Jordan',
    dial_code: '+962',
    code: 'JO',
  },
  {
    title: 'Kazakhstan',
    dial_code: '+7 7',
    code: 'KZ',
  },
  {
    title: 'Kenya',
    dial_code: '+254',
    code: 'KE',
  },
  {
    title: 'Kiribati',
    dial_code: '+686',
    code: 'KI',
  },
  {
    title: "Korea, Democratic People's Republic of Korea",
    dial_code: '+850',
    code: 'KP',
  },
  {
    title: 'Korea, Republic of South Korea',
    dial_code: '+82',
    code: 'KR',
  },
  {
    title: 'Kuwait',
    dial_code: '+965',
    code: 'KW',
  },
  {
    title: 'Kyrgyzstan',
    dial_code: '+996',
    code: 'KG',
  },
  {
    title: 'Laos',
    dial_code: '+856',
    code: 'LA',
  },
  {
    title: 'Latvia',
    dial_code: '+371',
    code: 'LV',
  },
  {
    title: 'Lebanon',
    dial_code: '+961',
    code: 'LB',
  },
  {
    title: 'Lesotho',
    dial_code: '+266',
    code: 'LS',
  },
  {
    title: 'Liberia',
    dial_code: '+231',
    code: 'LR',
  },
  {
    title: 'Libyan Arab Jamahiriya',
    dial_code: '+218',
    code: 'LY',
  },
  {
    title: 'Liechtenstein',
    dial_code: '+423',
    code: 'LI',
  },
  {
    title: 'Lithuania',
    dial_code: '+370',
    code: 'LT',
  },
  {
    title: 'Luxembourg',
    dial_code: '+352',
    code: 'LU',
  },
  {
    title: 'Macao',
    dial_code: '+853',
    code: 'MO',
  },
  {
    title: 'Macedonia',
    dial_code: '+389',
    code: 'MK',
  },
  {
    title: 'Madagascar',
    dial_code: '+261',
    code: 'MG',
  },
  {
    title: 'Malawi',
    dial_code: '+265',
    code: 'MW',
  },
  {
    title: 'Malaysia',
    dial_code: '+60',
    code: 'MY',
  },
  {
    title: 'Maldives',
    dial_code: '+960',
    code: 'MV',
  },
  {
    title: 'Mali',
    dial_code: '+223',
    code: 'ML',
  },
  {
    title: 'Malta',
    dial_code: '+356',
    code: 'MT',
  },
  {
    title: 'Marshall Islands',
    dial_code: '+692',
    code: 'MH',
  },
  {
    title: 'Martinique',
    dial_code: '+596',
    code: 'MQ',
  },
  {
    title: 'Mauritania',
    dial_code: '+222',
    code: 'MR',
  },
  {
    title: 'Mauritius',
    dial_code: '+230',
    code: 'MU',
  },
  {
    title: 'Mayotte',
    dial_code: '+262',
    code: 'YT',
  },
  {
    title: 'Mexico',
    dial_code: '+52',
    code: 'MX',
  },
  {
    title: 'Micronesia, Federated States of Micronesia',
    dial_code: '+691',
    code: 'FM',
  },
  {
    title: 'Moldova',
    dial_code: '+373',
    code: 'MD',
  },
  {
    title: 'Monaco',
    dial_code: '+377',
    code: 'MC',
  },
  {
    title: 'Mongolia',
    dial_code: '+976',
    code: 'MN',
  },
  {
    title: 'Montenegro',
    dial_code: '+382',
    code: 'ME',
  },
  {
    title: 'Montserrat',
    dial_code: '+1664',
    code: 'MS',
  },
  {
    title: 'Morocco',
    dial_code: '+212',
    code: 'MA',
  },
  {
    title: 'Mozambique',
    dial_code: '+258',
    code: 'MZ',
  },
  {
    title: 'Myanmar',
    dial_code: '+95',
    code: 'MM',
  },
  {
    title: 'Namibia',
    dial_code: '+264',
    code: 'NA',
  },
  {
    title: 'Nauru',
    dial_code: '+674',
    code: 'NR',
  },
  {
    title: 'Nepal',
    dial_code: '+977',
    code: 'NP',
  },
  {
    title: 'Netherlands',
    dial_code: '+31',
    code: 'NL',
  },
  {
    title: 'Netherlands Antilles',
    dial_code: '+599',
    code: 'AN',
  },
  {
    title: 'New Caledonia',
    dial_code: '+687',
    code: 'NC',
  },
  {
    title: 'New Zealand',
    dial_code: '+64',
    code: 'NZ',
  },
  {
    title: 'Nicaragua',
    dial_code: '+505',
    code: 'NI',
  },
  {
    title: 'Niger',
    dial_code: '+227',
    code: 'NE',
  },
  {
    title: 'Nigeria',
    dial_code: '+234',
    code: 'NG',
  },
  {
    title: 'Niue',
    dial_code: '+683',
    code: 'NU',
  },
  {
    title: 'Norfolk Island',
    dial_code: '+672',
    code: 'NF',
  },
  {
    title: 'Northern Mariana Islands',
    dial_code: '+1 670',
    code: 'MP',
  },
  {
    title: 'Norway',
    dial_code: '+47',
    code: 'NO',
  },
  {
    title: 'Oman',
    dial_code: '+968',
    code: 'OM',
  },
  {
    title: 'Pakistan',
    dial_code: '+92',
    code: 'PK',
  },
  {
    title: 'Palau',
    dial_code: '+680',
    code: 'PW',
  },
  {
    title: 'Palestinian Territory, Occupied',
    dial_code: '+970',
    code: 'PS',
  },
  {
    title: 'Panama',
    dial_code: '+507',
    code: 'PA',
  },
  {
    title: 'Papua New Guinea',
    dial_code: '+675',
    code: 'PG',
  },
  {
    title: 'Paraguay',
    dial_code: '+595',
    code: 'PY',
  },
  {
    title: 'Peru',
    dial_code: '+51',
    code: 'PE',
  },
  {
    title: 'Philippines',
    dial_code: '+63',
    code: 'PH',
  },
  {
    title: 'Pitcairn',
    dial_code: '+872',
    code: 'PN',
  },
  {
    title: 'Poland',
    dial_code: '+48',
    code: 'PL',
  },
  {
    title: 'Portugal',
    dial_code: '+351',
    code: 'PT',
  },
  {
    title: 'Puerto Rico',
    dial_code: '+1 939',
    code: 'PR',
  },
  {
    title: 'Qatar',
    dial_code: '+974',
    code: 'QA',
  },
  {
    title: 'Romania',
    dial_code: '+40',
    code: 'RO',
  },
  {
    title: 'Russia',
    dial_code: '+7',
    code: 'RU',
  },
  {
    title: 'Rwanda',
    dial_code: '+250',
    code: 'RW',
  },
  {
    title: 'Reunion',
    dial_code: '+262',
    code: 'RE',
  },
  {
    title: 'Saint Barthelemy',
    dial_code: '+590',
    code: 'BL',
  },
  {
    title: 'Saint Helena, Ascension and Tristan Da Cunha',
    dial_code: '+290',
    code: 'SH',
  },
  {
    title: 'Saint Kitts and Nevis',
    dial_code: '+1 869',
    code: 'KN',
  },
  {
    title: 'Saint Lucia',
    dial_code: '+1 758',
    code: 'LC',
  },
  {
    title: 'Saint Martin',
    dial_code: '+590',
    code: 'MF',
  },
  {
    title: 'Saint Pierre and Miquelon',
    dial_code: '+508',
    code: 'PM',
  },
  {
    title: 'Saint Vincent and the Grenadines',
    dial_code: '+1 784',
    code: 'VC',
  },
  {
    title: 'Samoa',
    dial_code: '+685',
    code: 'WS',
  },
  {
    title: 'San Marino',
    dial_code: '+378',
    code: 'SM',
  },
  {
    title: 'Sao Tome and Principe',
    dial_code: '+239',
    code: 'ST',
  },
  {
    title: 'Saudi Arabia',
    dial_code: '+966',
    code: 'SA',
  },
  {
    title: 'Senegal',
    dial_code: '+221',
    code: 'SN',
  },
  {
    title: 'Serbia',
    dial_code: '+381',
    code: 'RS',
  },
  {
    title: 'Seychelles',
    dial_code: '+248',
    code: 'SC',
  },
  {
    title: 'Sierra Leone',
    dial_code: '+232',
    code: 'SL',
  },
  {
    title: 'Singapore',
    dial_code: '+65',
    code: 'SG',
  },
  {
    title: 'Slovakia',
    dial_code: '+421',
    code: 'SK',
  },
  {
    title: 'Slovenia',
    dial_code: '+386',
    code: 'SI',
  },
  {
    title: 'Solomon Islands',
    dial_code: '+677',
    code: 'SB',
  },
  {
    title: 'Somalia',
    dial_code: '+252',
    code: 'SO',
  },
  {
    title: 'South Africa',
    dial_code: '+27',
    code: 'ZA',
  },
  {
    title: 'South Georgia and the South Sandwich Islands',
    dial_code: '+500',
    code: 'GS',
  },
  {
    title: 'Spain',
    dial_code: '+34',
    code: 'ES',
  },
  {
    title: 'Sri Lanka',
    dial_code: '+94',
    code: 'LK',
  },
  {
    title: 'Sudan',
    dial_code: '+249',
    code: 'SD',
  },
  {
    title: 'Surititle',
    dial_code: '+597',
    code: 'SR',
  },
  {
    title: 'Svalbard and Jan Mayen',
    dial_code: '+47',
    code: 'SJ',
  },
  {
    title: 'Swaziland',
    dial_code: '+268',
    code: 'SZ',
  },
  {
    title: 'Sweden',
    dial_code: '+46',
    code: 'SE',
  },
  {
    title: 'Switzerland',
    dial_code: '+41',
    code: 'CH',
  },
  {
    title: 'Syrian Arab Republic',
    dial_code: '+963',
    code: 'SY',
  },
  {
    title: 'Taiwan',
    dial_code: '+886',
    code: 'TW',
  },
  {
    title: 'Tajikistan',
    dial_code: '+992',
    code: 'TJ',
  },
  {
    title: 'Tanzania, United Republic of Tanzania',
    dial_code: '+255',
    code: 'TZ',
  },
  {
    title: 'Thailand',
    dial_code: '+66',
    code: 'TH',
  },
  {
    title: 'Timor-Leste',
    dial_code: '+670',
    code: 'TL',
  },
  {
    title: 'Togo',
    dial_code: '+228',
    code: 'TG',
  },
  {
    title: 'Tokelau',
    dial_code: '+690',
    code: 'TK',
  },
  {
    title: 'Tonga',
    dial_code: '+676',
    code: 'TO',
  },
  {
    title: 'Trinidad and Tobago',
    dial_code: '+1 868',
    code: 'TT',
  },
  {
    title: 'Tunisia',
    dial_code: '+216',
    code: 'TN',
  },
  {
    title: 'Turkey',
    dial_code: '+90',
    code: 'TR',
  },
  {
    title: 'Turkmenistan',
    dial_code: '+993',
    code: 'TM',
  },
  {
    title: 'Turks and Caicos Islands',
    dial_code: '+1 649',
    code: 'TC',
  },
  {
    title: 'Tuvalu',
    dial_code: '+688',
    code: 'TV',
  },
  {
    title: 'Uganda',
    dial_code: '+256',
    code: 'UG',
  },
  {
    title: 'Ukraine',
    dial_code: '+380',
    code: 'UA',
  },
  {
    title: 'United Arab Emirates',
    dial_code: '+971',
    code: 'AE',
  },
  {
    title: 'United Kingdom',
    dial_code: '+44',
    code: 'GB',
  },
  {
    title: 'United States',
    dial_code: '+1',
    code: 'US',
  },
  {
    title: 'Uruguay',
    dial_code: '+598',
    code: 'UY',
  },
  {
    title: 'Uzbekistan',
    dial_code: '+998',
    code: 'UZ',
  },
  {
    title: 'Vanuatu',
    dial_code: '+678',
    code: 'VU',
  },
  {
    title: 'Venezuela, Bolivarian Republic of Venezuela',
    dial_code: '+58',
    code: 'VE',
  },
  {
    title: 'Vietnam',
    dial_code: '+84',
    code: 'VN',
  },
  {
    title: 'Virgin Islands, British',
    dial_code: '+1 284',
    code: 'VG',
  },
  {
    title: 'Virgin Islands, U.S.',
    dial_code: '+1 340',
    code: 'VI',
  },
  {
    title: 'Wallis and Futuna',
    dial_code: '+681',
    code: 'WF',
  },
  {
    title: 'Yemen',
    dial_code: '+967',
    code: 'YE',
  },
  {
    title: 'Zambia',
    dial_code: '+260',
    code: 'ZM',
  },
  {
    title: 'Zimbabwe',
    dial_code: '+263',
    code: 'ZW',
  },
];
